export default function CTASection() {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[560px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20inviting%20scene%20of%20carefully%20wrapped%20brown%20paper%20packages%20tied%20with%20natural%20twine%20next%20to%20a%20steaming%20ceramic%20mug%20on%20cream%20textured%20surface%20soft%20golden%20hour%20sunlight%20streaming%20through%20sheer%20curtains%20creating%20dreamy%20atmosphere%20editorial%20photography%20cozy%20aspirational%20composition%20with%20generous%20negative%20space&width=1600&height=900&seq=itaobuy-cta-bg-v4&orientation=landscape"
          alt="Get the full itaobuy spreadsheet with curated China products"
          title="Access the Complete Itaobuy Spreadsheet"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 tracking-wide mb-4">
          GET THE FULL SPREADSHEET
        </h2>
        <p className="text-sm md:text-base text-background-50/80 max-w-xl mx-auto leading-relaxed mb-8">
          2,400+ curated China products
          <br />
          Daily updates, agent-ready links
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer group"
        >
          <span className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center group-hover:bg-primary-400 transition-colors">
            <i className="ri-shopping-bag-line text-base text-background-50" />
          </span>
          <span>BUY IT NOW</span>
          <i className="ri-arrow-right-up-line text-sm" />
        </a>
      </div>
    </section>
  );
}